
import FoldersCollection from "../Collections/FoldersCollection";
import FolderItem        from "./FolderItem";

export { FoldersData as default };

/**
* Folders Data
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FoldersData {
  /**
   * All Folders entity
   *
   * @public
   *
   * @type {FoldersCollection}
   *
   * @since 7.0.0
   */
  all = new FoldersCollection();

  /**
   * Main Folders entity
   *
   * @public
   *
   * @type {FoldersCollection}
   *
   * @since 7.0.0
   */
  main = new FoldersCollection();

  /**
   * Main Folders entity
   *
   * @public
   *
   * @type {FoldersCollection}
   *
   * @since 7.0.0
   */
   custom = new FoldersCollection();

  /**
   * Folder Switch
   *
   * @public
   *
   * @type {FolderItem}
   *
   * @since 7.0.0
   */
  folder_switch;
}